module.exports = {
    title:"Explore Best Books",
    description: "Find best books to read in Fiction, History, Writing, Leadership, Product Management and more",
    heading: "Explore Books By Genre"
}